/**
 * Navigazione a pagine su un solo URL: `?page=<nome>`.
 *
 * Il frontend non ha un router. Fino alla Fase 1 il cambio pagina usava
 * `replaceState`, quindi il tasto Indietro del browser non tornava mai alla
 * pagina precedente. Con le pagine di accesso e l'area clienti serve la
 * cronologia: `App` usa `pushState` e ascolta `popstate`, e queste funzioni
 * pure decidono URL e pagina. Sono qui, fuori dal JSX, per essere provate
 * senza montare la landing (che tira dentro pdf.js).
 */

export const PAGINE = [
  "landing", "anonymize", "privacy", "cookie",
  "accesso", "registrazione", "verifica", "password", "invito", "account",
];

/** Parametri di stato che non devono sopravvivere a un cambio pagina. */
const EFFIMERI = ["payment", "session_id", "recupero", "lavori", "dal", "token", "tipo", "verifica", "abbonamento", "next", "piano", "cadenza"];

/** @param {string} search la `window.location.search` */
export function paginaDaUrl(search) {
  const p = new URLSearchParams(search || "").get("page");
  return PAGINE.includes(p) ? p : "landing";
}

/** Tutti i parametri della query come oggetto semplice. */
export function parametri(search) {
  const out = {};
  new URLSearchParams(search || "").forEach((v, k) => { out[k] = v; });
  return out;
}

/**
 * URL (pathname + search) per mostrare `pagina`, ripartendo da `hrefCorrente`.
 * I parametri effimeri della pagina precedente vengono tolti; quelli in
 * `params` vengono aggiunti (con valore null si tolgono).
 *
 * @param {string} hrefCorrente `window.location.href`
 * @param {string} pagina una di PAGINE
 * @param {Record<string, string|null|undefined>} [params]
 */
export function urlPerPagina(hrefCorrente, pagina, params = {}) {
  const url = new URL(hrefCorrente, "http://localhost");
  if (pagina && pagina !== "landing") url.searchParams.set("page", pagina);
  else url.searchParams.delete("page");
  for (const chiave of EFFIMERI) url.searchParams.delete(chiave);
  for (const [chiave, valore] of Object.entries(params || {})) {
    if (valore === null || valore === undefined || valore === "") url.searchParams.delete(chiave);
    else url.searchParams.set(chiave, String(valore));
  }
  return `${url.pathname}${url.search}`;
}
